module.exports = __webpack_public_path__ + "static/media/dost_angry.801b677d.gif";